import React, { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../shared/ShowError';
import Laoding from '../shared/Laoding';

export default function StartBuyFromOtherSystem(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [searchParams] = useSearchParams();
    const enName = searchParams.get("enName");
    const otherSystemIdentity = searchParams.get("otherSystemIdentity");
    const mobile = searchParams.get("mobile");
    const firstname = searchParams.get("firstname");
    const lastname = searchParams.get("lastname");
    const companyTitle = searchParams.get("companyTitle");
    

    useEffect(() => {
        util.deleteOtherSystemDetail();
        util.saveOtherSystemDetail(otherSystemIdentity, mobile, firstname, lastname, enName, companyTitle);
        setRedirectUrl("/buy-product")
    }, []);
    
    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال بررسی داده ها..." />
                </Col>
            </Row>
        </>
    )
}